import React, { lazy } from 'react'
import { createBrowserRouter } from 'react-router-dom'

import allRoutes from 'shared/lib/allRoutes'
import { privateLoader, publicLoader } from './helper'
// import { publicLoader } from 'router/helper'

const Root = lazy(() => import('layout/root'))
const AuthHeader = lazy(() => import('layout/auth-header'))
const PublicHeader = lazy(() => import('layout/public-header'))
const SharedLayout = lazy(() => import('layout/shared-layout'))
const PrivateLayout = lazy(() => import('layout/private-layout'))

const ViaStructure = lazy(() => import('app/public/via-structure'))
const ExploreStackUp = lazy(() => import('app/public/explore-stack-up'))
const StackUpDetails = lazy(() => import('app/public/stack-up-details'))
const CMS = lazy(() => import('app/public/cms'))

const Login = lazy(() => import('app/auth/login'))
const ForgotPassword = lazy(() => import('app/auth/forgot-password'))
const SignUp = lazy(() => import('app/auth/signUp'))
const Verification = lazy(() => import('app/auth/verification'))
const Projects = lazy(() => import('app/private/projects'))
const MaterialListingPage = lazy(() => import('app/private/material-listing'))
const EditStackUp = lazy(() => import('app/private/edit-stack-up'))

export const routes = (queryClient) =>
  createBrowserRouter([
    {
      id: 'root',
      element: <Root />,
      children: [
        {
          element: <SharedLayout header={<AuthHeader />} />,
          loader: publicLoader,
          children: [
            {
              path: allRoutes.login,
              element: <Login />
            },
            {
              path: allRoutes.forgotPassword,
              element: <ForgotPassword />
            },
            {
              path: allRoutes.signUp,
              element: <SignUp />
            },
            {
              path: allRoutes.verification,
              element: <Verification />
            },
            {
              path: allRoutes.emailVerification(':token'),
              element: <Verification />
            }
          ]
        },
        {
          element: <SharedLayout header={<PublicHeader />} />,
          handle: { title: 'Explore Via Structure' },
          // loader: publicLoader,
          children: [
            {
              path: allRoutes.viaStructure,
              element: <ViaStructure />
            },
            {
              path: allRoutes.exploreStackUp(':sViaStructureId'),
              handle: { title: 'Explore Stack-up', isBack: true },
              element: <ExploreStackUp />
            },
            {
              path: allRoutes.stackUpListing,
              handle: { title: 'Explore Stack-up', isBack: true },
              element: <ExploreStackUp />
            },
            {
              path: allRoutes.stackUpDetails(':iStackupId'),
              handle: { title: 'Stack-up Details', isBack: true },
              element: <StackUpDetails />
            },
            {
              path: allRoutes.cms(':slug'),
              handle: { title: 'Content', isBack: true },
              element: <CMS />
            }
          ]
        },
        {
          element: <PrivateLayout />,
          loader: privateLoader(queryClient),
          children: [
            {
              path: allRoutes.projects,
              element: <Projects />
            },
            {
              path: allRoutes.materialListing,
              element: <MaterialListingPage />
            },
            {
              path: allRoutes.editStackUp(':iProjectId'),
              element: <EditStackUp />
            }
          ]
        }
      ]
    }
  ])
